import { useState } from "react";
import {
  FaHome,
  FaUser,
  FaTimes,
  FaUsers,
  FaUserTie,
  FaAddressBook,
  FaEnvelope,
  FaComments,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa";

import { NavLink, useNavigate } from "react-router-dom";

export default function UserSidebar({ isOpen, onClose }) {
  const navigate = useNavigate();

  const [contactOpen, setContactOpen] = useState(false);

  const handleContactClick = () => {
    setContactOpen(!contactOpen);
    navigate("/ContactMangement");
  };

  return (
    <div className={`sidebar ${isOpen ? "active" : ""}`}>
      <div className="sidebar-header">
        <div className="logo">Shreemwell</div>
        <FaTimes className="close-btn" onClick={onClose} />
      </div>

      <ul className="menu">
        {/* Dashboard */}
        <NavLink to="/user-dashboard">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaHome />
              </div>
              <span>Dashboard</span>
            </li>
          )}
        </NavLink>

        {/* Profile */}
        <NavLink to="/user-profile">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaUser />
              </div>
              <span>Profile</span>
            </li>
          )}
        </NavLink>

        {/* Contact Management */}
        <li
          className={`submenu-parent ${contactOpen ? "active" : ""}`}
          onClick={handleContactClick}
        >
          <div className="icon-box">
            <FaAddressBook />
          </div>

          <span className="menu-title">Contact Management</span>

          <div className="submenu-arrow">
            {contactOpen ? <FaChevronDown /> : <FaChevronRight />}
          </div>
        </li>

        {/* Sub Menu */}
        {contactOpen && (
          <ul className="submenu">
            <NavLink to="/MutualManagement">
              {({ isActive }) => (
                <li className={isActive ? "active" : ""}>
                  Mutual Management
                </li>
              )}
            </NavLink>
          </ul>
        )}

        {/* Team */}
        <NavLink to="/Team-view">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaUsers />
              </div>
              <span>Team Management</span>
            </li>
          )}
        </NavLink>

        {/* Lead */}
        <NavLink to="/lead">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaUserTie />
              </div>
              <span>Lead Management</span>
            </li>
          )}
        </NavLink>

        {/* Greeting */}
        <NavLink to="/greeting">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaEnvelope />
              </div>
              <span>Greeting</span>
            </li>
          )}
        </NavLink>

        {/* Communication */}
        <NavLink to="/communication">
          {({ isActive }) => (
            <li className={isActive ? "active" : ""}>
              <div className="icon-box">
                <FaComments />
              </div>
              <span>Communication</span>
            </li>
          )}
        </NavLink>
      </ul>
    </div>
  );
}